import countTo from 'vue-count-to'

export default {
  countTo
}



// WEBPACK FOOTER //
// ./src/app/dweller/dashboard/gadget/resources/components.js